import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { InversCloudBoxxSettings } from "./app-settings-config-invers-cloud-boxx";

export interface IInversCloudBoxxInputState {
  showModal: boolean;
  editingInversCloudBoxxId: string;
}

export interface IInversCloudBoxxInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class InversCloudBoxxInput extends PureComponent<IInversCloudBoxxInputProps, IInversCloudBoxxInputState> {
  formInputName = ["apiConfig", "inversCloudBoxxSettingsId"];

  constructor(props: IInversCloudBoxxInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingInversCloudBoxxId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingInversCloudBoxxId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ editingInversCloudBoxxId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;
    return (
      <>
        <InversCloudBoxxSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingInversCloudBoxxId={this.state.editingInversCloudBoxxId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <div style={{ marginTop: 16 }}>
          <ConfigSettingSelect
            label="Configuration"
            formInputName={this.formInputName}
            options={this.props.commonSettings?.inversCloudBoxxSettings ?? []}
            allowClear
            tooltipContentKey="appsettings_inverscloudboxx_configuration"
            onAddNew={this.openModal}
            onEdit={this.setEditingSetting}
            parentConfigValue={this.props.parentConfigValue}
            onRestore={this.handleRestore}
            dropdownTestId="appSettingsInversCloudBoxxDropdown"
            addNewTestId="appSettingsInversCloudBoxxAddNewButton"
            editTestId="appSettingsInversCloudBoxxEditButton"
          />
        </div>
      </>
    );
  }
}
